import merge from 'lodash/merge';
import BackboneElement from './BackboneElement';
import BN_Asam4LevelOfCareCriteriaTerminologyTransition from './BN_Asam4LevelOfCareCriteriaTerminologyTransition';

export default class BN_Asam4LevelOfCareCriteriaTerminologyLevel extends BackboneElement {
    static __className = 'BN_Asam4LevelOfCareCriteriaTerminologyLevel';

    __objectStructure = {
        level: String,
        title: String,
        transitions: [BN_Asam4LevelOfCareCriteriaTerminologyTransition],
    };

    constructor(constructJson, className = 'BN_Asam4LevelOfCareCriteriaTerminologyLevel') {
        super(constructJson, className);

        this.createAndPopulateStructure(this.__objectStructure, constructJson);

        this.originalObjJson = this.toJSON();
    }

    toJSON() {
        return merge(super.toJSON(this), this.getJsonForStructure(this.__objectStructure));
    }
}
